import { useState, useEffect } from "react";
import "./RPLeftPanelComponent.scss";
import { useDispatch } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent";
import VideoPlayer from "react-video-js-player";
import RolePlayVideoRecord from "../../../RolePlay/RolePlayVideoRecord";
import { useTranslation } from "react-i18next";
const RPLeftPanelComponent = (props) => {
  const {
    id,
    productData,
    rpData,
    isLoading,
    setIsLoading,
    setShowModalMsg,
    setLoaderMsg,
    setConfirmModal,
    setShowGreenTick,
    view,
    setReload,
  } = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [key, setKey] = useState("instructions");
  const [showRecordArea, setShowRecordArea] = useState(false);

  useEffect(() => {}, [showRecordArea]);

  const renderInfo = () => {
    return (
      <>
        <div className="row">
          <VideoPlayer
            id={`assigned-video`}
            controls={true}
            src={productData.videoURL ? productData.videoURL : ""}
            width="720"
            height="420"
            autoPictureInPicture={false}
            fluid={true}
            inline={false}
            pictureInPictureToggle={false}
            poster={productData.bannerURL}
            textTrackSettings={false}
            type={
              productData.videoURL && productData?.videoURL.includes(".mp4")
                ? "video/mp4"
                : "application/x-mpegURL"
            }
          />
        </div>
        <div className="roleplay-tab-body">
          <div className="contsection">
            <Tabs
              underline
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
              }}
            >
              <Tab eventKey={"instructions"} title={t("Instructions")}>
                <div className="row instruction-panel">
                  <div className="ins-panel-title">{t("How to")}?</div>
                  <div
                    className="ins-panel-body"
                    dangerouslySetInnerHTML={{
                      __html: productData.instruction,
                    }}
                  ></div>
                </div>
              </Tab>
              {false && (
                <Tab eventKey={"parametes"} title="Parameters">
                  ...
                </Tab>
              )}
            </Tabs>
          </div>
        </div>
        <div className="row rp-panel-footer">
          <div className="d-flex justify-content-end gap-4">
            <div className="d-flex justify-content-end gap-4 rp-panel-btn">
              <FormButtonComponent
                btnName={t("Upload video or audio")}
                leftIcon=""
                rightIcon=""
                isDisabled={productData.purchaseInfo?.isFree ? false : true}
                isPrimary={false}
                replaceClassName="startcourse-btn"
                btnAction={() => setShowRecordArea(true)}
              />
              <FormButtonComponent
                btnName={t("Record video or audio")}
                leftIcon=""
                rightIcon=""
                isDisabled={productData.purchaseInfo?.isFree ? false : true}
                isPrimary={true}
                replaceClassName="startcourse-btn"
                btnAction={() => setShowRecordArea(true)}
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="rp-left-panel-content">
      {showRecordArea ? (
        // {/* Show Video Record Section */}
        <RolePlayVideoRecord
          page="participate"
          roleData={rpData}
          //   listing={participateRoleList}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          setShowRecordArea={setShowRecordArea}
          setShowModalMsg={setShowModalMsg}
          setConfirmModal={setConfirmModal}
          //   setShowModalMsg={() => {}}
          setLoaderMsg={setLoaderMsg}
          rolePlayTabName={productData?.title}
          setReload={setReload}
          setShowGreenTick={setShowGreenTick}
        />
      ) : (
        renderInfo()
      )}
    </div>
  );
};

export default RPLeftPanelComponent;
